<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { MixpanelInstance } from '@/plugins/mixpanel/mixpanel';

const router = useRouter();
const route = useRoute();
const isOpen = ref(false);

function openShareProfile() {
  MixpanelInstance.track('mobile_sharers_click_share');
  isOpen.value = false;
  router.push({ name: route.name as string, query: { share: 'link' } });
}
</script>

<template>
  <v-btn
    @click="openShareProfile"
    class="bg-white px-3 py-2 fixed bottom-20 right-4 z-10"
    size="auto"
    variant="outlined"
    icon
    color="grey"
  >
    <v-icon icon="fa-thin fa-share-nodes" :size="20" />
    <span class="ml-2 font-weight-regular">{{ $t('candidate_account.share.cta') }}</span>
    <v-tooltip activator="parent" location="bottom">
      {{ $t('candidate_profile.share_profile.button_tooltip') }}
    </v-tooltip>
  </v-btn>
</template>
